import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme: any) => {
  console.log(theme);
  return {
    root: {
      width: "100%",
      position: "relative",
      padding: "2rem",
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
      alignItems: "flex-start",
    },
    buttonContainer: {
      width: "100%",
    },
    button: {
      width: "100%",
    },
    markdownContainer: {
      width: "100%",
      border: `1px solid ${theme.palette.background.default}`,
    },
    markdownEditorWrapper: {
      width: "100%",
      color: "#000",
      border: `1px solid ${theme.palette.background.default}`,
    },
    markdownEditor: {
      color: "#fff",
      padding: "1rem",
    },
    markdownToolbar: {
      background: "transparent",
      borderBottom: `1px solid ${theme.palette.background.default}`,
      borderTop: "none",
      borderRight: "none",
      borderLeft: "none",
    },
  };
});
